import * as autosize from "autosize";

/* global particlesJS */

let currentPage = null;
let syncWithInstructor = null;
let nbPages = null;
let particlesSet = null;
let pollingTimeout = null;
let formInputsAnswers = {};

$(document)
  .on("click", ".answer-activity .next-question", onNextQuestion)
  .on("click", ".answer-activity .start-unsync", onStartUnsync)
  .on("click", ".edit-activity .insert-buttons button", onRecolor);

document.addEventListener("DOMContentLoaded", function () {
  currentPage = window.currentPage || 0;
  syncWithInstructor = window.syncWithInstructor || true;
  nbPages = 1;
  particlesSet = null;
  formInputsAnswers = {};
  clearTimeout(pollingTimeout);

  if ($(".answer-activity").length > 0) {
    setTimeout(init, 500); // necessary to snif the content
  }

  if ($(".activity-results").length > 0) {
    currentPage = 0;
    particlesSet = null;
  }

  onRecolor();
});

//------------------------------------------------------------------------
// init
//------------------------------------------------------------------------
async function init() {
  await import("particles.js");

  nbPages = $(".input").length;
  showCurrentPage();
  pollingTimeout = setTimeout(pollCurrentPage, 3000);
}

//------------------------------------------------------------------------
// onRecolor
//------------------------------------------------------------------------
function onRecolor() {
  if ($(".edit-activity").length > 0) {
    setTimeout(function () {
      setResultsInputBackgrounds(".js-form-input");
    }, 100);
  }
}

function pollCurrentPage() {
  ajax({ url: window.pollCurrentPagePath, dataType: "json" }).done(function (data) {
    if (data.success) {
      let current_page = parseInt(data.current_page);
      if (current_page > currentPage || syncWithInstructor != data.sync_with_instructor) {
        currentPage = current_page;
        syncWithInstructor = data.sync_with_instructor;
        showCurrentPage();
      }
    }
    pollingTimeout = setTimeout(pollCurrentPage, 3000);
  });
}

//------------------------------------------------------------------------
// Buttons
//------------------------------------------------------------------------
function onNextQuestion() {
  if (currentPage >= nbPages) {
    if (window.is_admin) {
      localStorage.removeItem("form_temp_answers"); // NORMALLY DONE IN FORMS
      window.location.href = window.results_path;
    } else {
      document.querySelectorAll(".save-form").forEach((saveButton) => saveButton.click());
    }
  } else {
    currentPage += 1;
    showCurrentPage();
    if (window.is_admin) {
      ajax({
        type: "POST",
        url: window.setCurrentPagePath,
        data: {
          current_page: currentPage,
          sync_with_instructor: syncWithInstructor,
        },
      });
    }
  }
}

function onStartUnsync() {
  ajax({
    type: "POST",
    url: window.setCurrentPagePath,
    data: {
      current_page: currentPage,
      sync_with_instructor: false,
    },
    success: function () {
      window.location.href = window.results_path;
    },
  });
}

//------------------------------------------------------------------------
// showCurrentPage
//------------------------------------------------------------------------
async function showCurrentPage() {
  changeBackground();
  if (currentPage > 0) {
    $(".lobby").hide();
  }

  $(".input").css("top", "-5000px");

  const selected = document.querySelector(`.input[data-index="${currentPage - 1}"]`);

  if (selected) {
    const { default: velocity } = await import("velocity-animate");
    velocity(selected, { top: 0 }, { duration: 500 });
  }

  autosize($(".autoresize"));

  if (currentPage > 0) {
    $(".start-unsync").hide();
  }

  if (currentPage == 0 && syncWithInstructor == true) {
    if (window.is_admin) {
      $(".next-question").show().html("Lancer l'activité<br><span class='small'>en supervisant le passage des questions</span>");
    } else {
      $(".next-question").hide();
    }
  } else if (currentPage >= nbPages && window.is_admin) {
    $(".next-question").show().text("Voir les résultats !");
  } else if (currentPage >= nbPages) {
    $(".next-question").show().text("Envoyer mes réponses !");
  } else {
    if (window.is_admin || syncWithInstructor == false) {
      $(".next-question").show().text("Question suivante");
    } else {
      $(".next-question").hide();
    }
  }
  showAnswersCount();
}

function showAnswersCount() {
  if (window.is_admin && currentPage > 0) {
    let currentInputId = $(`.input[data-index=${currentPage - 1}]`).attr("data-id");
    let answerers = formInputsAnswers[currentInputId] || [];
    let traineesCount = $(".trainee").length;
    $(".answers-count").show();
    $(".answers-count .count").html(`${answerers.length}<span> / ${traineesCount}</span>`);
  } else {
    $(".answers-count").hide();
  }
}

//------------------------------------------------------------------------
// colors / particles / background
//------------------------------------------------------------------------
async function changeBackground() {
  const { default: velocity } = await import("velocity-animate");
  velocity(document.querySelector(".answer-activity"), { backgroundColor: colors(currentPage) }, { duration: 500 });
  particles();
}

function setResultsInputBackgrounds(selector) {
  $(selector).each(function (i) {
    let color = colors(i + 1);
    $(this).css("background", color);
  });
}

function colors(index) {
  if (index == 0) return "#F9F9F9";

  let choices = ["#8bc3db", "#e392a4", "#56c8c4", "#e3c492", "#92e396", "#cc92e3", "#a9b4de", "#e9df8d"];
  return choices[index % choices.length];
}

function particles() {
  setTimeout(function () {
    if (currentPage > 0 && particlesSet != 1) {
      particlesJS("particles-js", particlesJson);
      particlesSet = 1;
    } else if (particlesSet != 0 && currentPage == 0) {
      particlesJS("particles-js", lobbyParticleJson);
      particlesSet = 0;
    }
  }, 300);
}

let particlesJson = {
  particles: {
    number: {
      value: 6,
      density: {
        enable: true,
        value_area: 800,
      },
    },
    color: {
      value: "#ffffff",
    },
    shape: {
      type: "polygon",
      stroke: {
        width: 0,
        color: "#000",
      },
      polygon: {
        nb_sides: 6,
      },
      image: {
        src: "img/github.svg",
        width: 100,
        height: 100,
      },
    },
    opacity: {
      value: 0.04,
      random: true,
      anim: {
        enable: false,
        speed: 0.5,
        opacity_min: 0.1,
        sync: false,
      },
    },
    size: {
      value: 500,
      random: false,
      anim: {
        enable: true,
        speed: 12.173348482389219,
        size_min: 8.927122220418761,
        sync: false,
      },
    },
    line_linked: {
      enable: false,
      distance: 400.63781540212045,
      color: "#040404",
      opacity: 0.2564082018573571,
      width: 20,
    },
    move: {
      enable: true,
      speed: 2,
      direction: "none",
      random: false,
      straight: false,
      out_mode: "out",
      bounce: false,
      attract: {
        enable: false,
        rotateX: 600,
        rotateY: 1200,
      },
    },
  },
  interactivity: {
    detect_on: "canvas",
    events: {
      onhover: {
        enable: false,
        mode: "grab",
      },
      onclick: {
        enable: false,
        mode: "push",
      },
      resize: true,
    },
    modes: {
      grab: {
        distance: 400,
        line_linked: {
          opacity: 1,
        },
      },
      bubble: {
        distance: 400,
        size: 40,
        duration: 2,
        opacity: 8,
        speed: 3,
      },
      repulse: {
        distance: 200,
        duration: 0.4,
      },
      push: {
        particles_nb: 4,
      },
      remove: {
        particles_nb: 2,
      },
    },
  },
  retina_detect: true,
};

let lobbyParticleJson = {
  particles: {
    number: {
      value: 80,
      density: {
        enable: true,
        value_area: 800,
      },
    },
    color: {
      value: "#338cdb",
    },
    shape: {
      type: "circle",
      stroke: {
        width: 0,
        color: "#338cdb",
      },
      polygon: {
        nb_sides: 5,
      },
      image: {
        src: "img/github.svg",
        width: 100,
        height: 100,
      },
    },
    opacity: {
      value: 0.2,
      random: false,
      anim: {
        enable: false,
        speed: 1,
        opacity_min: 0.01,
        sync: false,
      },
    },
    size: {
      value: 3,
      random: true,
      anim: {
        enable: false,
        speed: 40,
        size_min: 0.1,
        sync: false,
      },
    },
    line_linked: {
      enable: true,
      distance: 150,
      color: "#338cdb",
      opacity: 0.2,
      width: 1,
    },
    move: {
      enable: true,
      speed: 6,
      direction: "none",
      random: false,
      straight: false,
      out_mode: "out",
      bounce: false,
      attract: {
        enable: false,
        rotateX: 600,
        rotateY: 1200,
      },
    },
  },
  interactivity: {
    detect_on: "canvas",
    events: {
      onhover: {
        enable: false,
        mode: "repulse",
      },
      onclick: {
        enable: false,
        mode: "push",
      },
      resize: true,
    },
    modes: {
      grab: {
        distance: 400,
        line_linked: {
          opacity: 1,
        },
      },
      bubble: {
        distance: 400,
        size: 40,
        duration: 2,
        opacity: 8,
        speed: 3,
      },
      repulse: {
        distance: 200,
        duration: 0.4,
      },
      push: {
        particles_nb: 4,
      },
      remove: {
        particles_nb: 2,
      },
    },
  },
  retina_detect: true,
};
